var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-player-wrapper"},[_c('video-player',{ref:"videoPlayerRef",attrs:{"playsinline":true,"options":_vm.playerOptions},on:{"ended":function($event){return _vm.onPlayerEnded($event)},"timeupdate":_vm.onPlayerTimeupdate}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ff9313e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/resource/player/resource-video-player.vue
// module id = null
// module chunks = 